// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"f0a44c91","200":"2f157d9f","213":"6b441753","239":"555a065e","453":"df86d28a","455":"21358d9f","477":"71167fd0","581":"7c163a01","700":"e4e7e316","952":"46a4e8a0"}[chunkId] + ".chunk.js";
};